import React from 'react';
import '../styles/CTABanner.css';

const CTABanner = () => {
  return (
    <div className="container">
      <div className="cta-banner">
        <div>
          <h2>Ready to play?</h2>
          <p>BookMyGround · instant booking · 200+ venues</p>
        </div>
        <button className="cta-btn">
          Find a ground <i className="fa-regular fa-arrow-right"></i>
        </button>
      </div>
    </div>
  );
};

export default CTABanner;